import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import StockIssueForm from '../../components/pageModule/Stockissues/StockIssueForm';
import { createStockIssue, setSelected, clearCurrentStockIssue } from '../../store/modules/stockissue/stockissueActions';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const StockissuesCreate = () => {
    const initialData = useRef({ initialType: 'create' });
    const [formKey, setFormKey] = useState(0); // Add key state
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Clear any existing data when component mounts
    useEffect(() => {
        dispatch(clearCurrentStockIssue());
    }, [dispatch]);

    const handleCreate = async (formData) => {
        try {
            const response = await dispatch(createStockIssue(formData));
            toast.success('Stock issue created successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            if (response && response.id) {
                // Reset initialData and force remount
                initialData.current = { 
                    initialType: 'create'
                };
                setFormKey(prev => prev + 1);
                // Optionally, you can navigate or just reset the form
                // navigate(`/job_orders/create`);
                // navigate(`/stock_issues/edit/${response.id}`);
            }
            return response;
        } catch (error) {
            toast.error(error.message || 'Error creating stock issue', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        create: handleCreate,
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
    };
    
    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <StockIssueForm 
                                    formLabel="Create Stock Issue"
                                    key={formKey} // Force remount on key change
                                    initialData={initialData.current}
                                    onSave={async (data) => {
                                        try {
                                            const response = await actions.create(data);
                                            return response;
                                        } catch (error) {
                                            console.error('Error creating item:', error);
                                            throw error;
                                        }
                                    }}
                                    onClose={() => {
                                        console.log('cancel btn clicked')
                                    }}
                                    customActionsDispatch={actions}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}
export default StockissuesCreate; 